import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'arrow-roundabout-right',
  'IconArrowRoundaboutRight',
  [
    ['path', { d: 'M21 9h-8a5 5 0 1 0 -5 5v7', key: 'svg-0' }],
    ['path', { d: 'M17 5l4 4l-4 4', key: 'svg-1' }],
  ],
);
